<template>
  <div>
    <apexchart
      type="bar"
      height="350"
      :options="ChartOptions"
      :series="Series"
    />
  </div>
</template>
<script>
export default {
  props: {
    headers: Array,
    series: Array,
    bar: Boolean
  },
  mounted: function() {
    this.Series = [
      {
        data: this.series
      }
    ];
    this.ChartOptions = {
      xaxis: {
        categories: this.headers
      }
    };
  },
  watch: {
    headers: {
      handler(data) {
        this.ChartOptions = {
          xaxis: {
            categories: data
          }
        };
      },
      deep: true
    },
    series: {
      handler(d_ata) {
        this.Series = [
          {
            data: d_ata
          }
        ];
      },
      deep: true
    }
  },
  data() {
    return {
      ChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },

        plotOptions: {
          bar: {
            horizontal: this.bar
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: this.headers,
          labels: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        yaxis: {
          labels: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          },
          tooltip: {
            enabled: true,
            offsetX: 0
          }
        }
      },
      Series: [
        {
          data: []
        }
      ]
    };
  }
};
</script>
